import React from "react";
import ReactDOM from "react-dom/client";
import { store, persistor } from "./store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import reportWebVitals from "./reportWebVitals";

import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

function loadDynamicCSS() {
  const isAdmin = window.location.pathname.startsWith("/admin");
  const cssFile = isAdmin ? "/admin.css" : "/user.css";
  const linkId = "area-css";
  let link = document.getElementById(linkId);
  if (!link) {
    link = document.createElement("link");
    link.id = linkId;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  if (link.getAttribute("href") !== cssFile) {
    link.setAttribute("href", cssFile);
  }
}

loadDynamicCSS();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PersistGate>
      </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
